import { render, staticRenderFns } from "./BindWeChat.vue?vue&type=template&id=48f20fea&scoped=true"
import script from "./BindWeChat.vue?vue&type=script&lang=js"
export * from "./BindWeChat.vue?vue&type=script&lang=js"
import style0 from "./BindWeChat.vue?vue&type=style&index=0&id=48f20fea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f20fea",
  null
  
)

export default component.exports